import { render } from "./TestInfoIconPopover.vue?vue&type=template&id=482540db"
import script from "./TestInfoIconPopover.vue?vue&type=script&lang=js"
export * from "./TestInfoIconPopover.vue?vue&type=script&lang=js"

import "./TestInfoIconPopover.vue?vue&type=style&index=0&id=482540db&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__